import React from 'react'
import { useTranslation } from 'react-i18next'

import { Icon } from 'src/components/ui'
import { formattedText } from 'src/utils/formattedText'

import type { NotificationType } from '../../Notifications.types'
import { getDate } from '../../utils/getDate'
import styles from './Notification.module.scss'

const Notification = ({ Bottle, User, created_at, type }: NotificationType) => {
  const { t } = useTranslation()
  const status = t(`notifications_page.${type}`)
  const time = getDate(created_at)

  return (
    <div className={styles.notification}>
      <div className={styles.notification_header}>
        <div className={styles['notification_header-status']}>
          {status === t('notifications_page.win') ? (
            <Icon name='winnerNotification' />
          ) : (
            <Icon name='defeatNotification' />
          )}
          <p>{status}</p>
        </div>

        <p className={styles['notification_header-time']}>{time}</p>
      </div>

      <div
        className={`${styles.notification_main} ${status === t('notifications_page.win') ? styles.winner : styles.defeat}`}
      >
        <div>
          <p className={styles['notification_main-title']}>{t('notifications_page.name_bank')}</p>
          <p className={styles['notification_main-text']}>{Bottle.name}</p>
        </div>
        <div>
          <p className={styles['notification_main-title']}>{t('notifications_page.owner')}</p>
          <p className={styles['notification_main-text']}>{User.username}</p>
        </div>
      </div>

      <div className={styles.notification_footer}>
        <p className={styles['notification_footer-title']}>{t('notifications_page.result')}</p>
        <div
          className={`${styles['notification_footer-result']} ${status === t('notifications_page.win') ? styles.winner : styles.defeat}`}
        >
          <p>
            {status === t('notifications_page.win') ? '+ ' : '- '} {formattedText(Bottle.entry_sum)}
          </p>
          <Icon name='star' />
        </div>
      </div>
    </div>
  )
}

export default Notification
